define(function(require, exports, module) {
    'use strict';

    var $ = require('j');
    var _ = require('underscore');
    var i18n = require('i18n');
    var userValidation = require('modules/user/user.validation.config');

    module.exports = function() {

        var validationConfig = userValidation();

        var isZeroAndIsInput = function(value, isInputType) {
            var isInvalidValue = !value && value !== 0;
            var isZeroValue = value === 0 && isInputType;
            return !(isInvalidValue || isZeroValue);
        };

        var isZeroAndIsDropdown = function(value, isInputType) {
            return value === 0 && !isInputType;
        };

        var isFitLimitAmount = {
            'session': function(data, isInputType) {
                var value = data.session;
                // deposit limit has editable dropdown type
                // 'isInputType' param use for loss/bet limits
                var isDepositLimit = _.isUndefined(isInputType);

                if (!isDepositLimit && !isZeroAndIsInput(value, isInputType)) {
                    return false;
                }
                if (!isDepositLimit && isZeroAndIsDropdown(value, isInputType)) {
                    return true;
                }
                if (data.day && data.day < value) {
                    return false;
                }
                if (data.week && data.week < value) {
                    return false;
                }
                if (data.month && data.month < value) {
                    return false;
                }

                return true;
            },
            'day': function(data, isInputType) {
                var value = data.day;

                if (!isZeroAndIsInput(value, isInputType)) {
                    return false;
                }
                if (isZeroAndIsDropdown(value, isInputType)) {
                    return true;
                }
                if (data.week && data.week < value) {
                    return false;
                }
                if (data.month && data.month < value) {
                    return false;
                }
                if (data.session && data.session > value) {
                    return false;
                }

                return true;
            },
            'week': function(data, isInputType) {
                var value = data.week;

                if (!isZeroAndIsInput(value, isInputType)) {
                    return false;
                }
                if (isZeroAndIsDropdown(value, isInputType)) {
                    return true;
                }
                if (data.day && data.day > value) {
                    return false;
                }
                if (data.month && data.month < value) {
                    return false;
                }
                if (data.session && data.session > value) {
                    return false;
                }

                return true;
            },
            'month': function(data, isInputType) {
                var value = data.month;

                if (!isZeroAndIsInput(value, isInputType)) {
                    return false;
                }
                if (isZeroAndIsDropdown(value, isInputType)) {
                    return true;
                }
                if (data.day && data.day > value) {
                    return false;
                }
                if (data.week && data.week > value) {
                    return false;
                }
                if (data.session && data.session > value) {
                    return false;
                }

                return true;
            }
        };

        /* next rules (address2, address3) is copied from reg. builder */

        validationConfig.address2.required = {
            message: i18n.t('playtech.mobile.system.user.tooltip.streetName.required')
        };

        validationConfig.address3.required = {
            message: i18n.t('playtech.mobile.system.user.tooltip.houseNumber.required')
        };

        validationConfig.address2.regexp.regexp = validationConfig.address3.regexp.regexp = /^[A-Za-züõöÖÄß0-9-,.'#&/\s]*$/;

        validationConfig.userName = _.extend({}, validationConfig.userName, {
            length: {
                min: 5,
                max: 32,
                message: i18n.t('playtech.mobile.system.user.tooltip.loginUserName.length', 5, 32)
            },
            regexp: {
                regexp: /^[A-Za-z0-9-.@_]+$/,
                message: i18n.t('playtech.mobile.system.user.tooltip.loginUserName.regexp')
            }
        });

        validationConfig.password = _.extend({}, validationConfig.password, {
            length: {
                min: 8,
                max: 20,
                message: i18n.t('playtech.mobile.system.user.tooltip.loginPassword.length', 8, 20)
            },
            regexp: {
                regexp: /^[A-Za-z0-9-.@_$%&!?+#\\\/,*]+$/,
                message: i18n.t('playtech.mobile.system.user.tooltip.loginPassword.regexp')
            }
        });

        validationConfig.limit.regexp.regexp = validationConfig.depositLimit.regexp.regexp = /^[0-9'.]+$/;

        validationConfig.limit = _.extend({}, validationConfig.limit, {
            fn: {
                fn: function($inputs, config, form, dfd, event, options) {
                    // check another fields
                    var fields = form.$el.find('[data-validation-type=limit]');

                    if (!fields.length) {
                        fields = form.$el.find('.fn-deposit-limit-generic');
                    }

                    if (form.validationInProgress !== true) {
                        form.validationInProgress = true;

                        _.each(fields, function(field) {
                            form.validateField($(field), options);
                        });

                        form.validationInProgress = false;
                    }

                    // check current field
                    var fieldTypesMatchedStr = 'session|day|week|month';
                    var isInputType = $inputs[0].tagName === 'INPUT';
                    var parsedData = _.chain(form.data())
                        .omit('betlimitaction', 'losslimitaction')
                        .mapObject(value => Number(value.replace(/'/, '')))
                        .value();
                    var changedField = $inputs[0].name.match(fieldTypesMatchedStr)[0];

                    // collect all value from form to correct object
                    // structured inputted form data to object {session: 0, ..., week: 1}
                    // check daily <= weekly <= monthly
                    var formattedData = _.keys(parsedData).reduce(function(memo, limitName) {
                        var matched = limitName.match(fieldTypesMatchedStr)[0];
                        memo[matched] = parsedData[limitName];
                        return memo;
                    }, {});

                    if (!isFitLimitAmount[changedField](formattedData, isInputType)) {
                        this.message = i18n.t('playtech.mobile.system.tooltip.limits.error.' + changedField);
                        return false;
                    }

                    return true;
                }
            }
        });

        validationConfig.depositLimit.fn.fn = function($inputs, config, form) {
            var options = form.options.data;
            var data = _.mapObject(form.data(), value => Number(value.replace(/'/, '')));
            var fieldName = $inputs[0].name;
            var value = Number($inputs.val().replace(/'/, ''));
            var viewFieldTypesMatchStr = 'daydeposit|weekdeposit|monthdeposit';
            var validationFieldTypesMatchStr = 'day|week|month';
            var isQuestionnairePopup = options.type === 'questionnaire';

            // check another fields
            var fields = form.$el.find('[data-validation-type=depositLimit]');
            if (!fields.length) {
                fields = form.$el.find('.fn-deposit-limit-generic');
            }

            if (!form.validationInProgress) {
                form.validationInProgress = true;

                _.each(fields, function(field) {
                    form.validateField($(field), options);
                });

                form.validationInProgress = false;
            }
            // format to {day:, week:, month:} for easy validation
            var formattedData = _.keys(data).reduce(function(memo, limitName) {
                var matched = limitName.match(viewFieldTypesMatchStr);
                if (matched) {
                    memo[matched[0].split('deposit')[0]] = data[limitName];
                }
                return memo;
            }, {});

            // check playerMustSetLimits & allPeriodsRequired & noLimitsAllowed
            var isAllLimitsAreEmpty = function(periods) {
                return _.every(_.pairs(periods), function(pair) {
                    return pair[1] === 0;
                });
            };
            if (options.playerMustSetLimits) {
                if (options.allPeriodsRequired && value === 0) {
                    this.message = i18n.t('playtech.mobile.system.tooltip.limits.allRequired');
                    return false;
                }
                if (!options.allPeriodsRequired && isAllLimitsAreEmpty(formattedData)) {
                    this.message = i18n.t('playtech.mobile.system.tooltip.limits.oneRequired');
                    return false;
                }
            }
            if (!options.allPeriodsRequired && value === 0) {
                return true;
            }

            // check daily <= weekly <= monthly
            var currentLimitName = fieldName.match(validationFieldTypesMatchStr)[0];

            if (!isFitLimitAmount[currentLimitName](formattedData)) {
                this.message = i18n.t('playtech.mobile.system.tooltip.limits.error.' + currentLimitName);
                return false;
            }

            // check if predefinedType = 'enabled'
            if (options && options.predefinedType === 'enabled' && !isQuestionnairePopup) {
                // skip range validation for 'Unlimited' and '0'
                if (options.noLimitsAllowed && value === Number(options.UNLIMITED_AMOUNT) || value === 0) {
                    return true;
                }
                var allowedLimits = options.allowedLimits.map(Number);
                var isEmptyAllowed = options.playerMustSetLimits && !options.allPeriodsRequired;

                if (options.noLimitsAllowed) {
                    allowedLimits.pop();
                }

                var min = Math.min.apply(null, allowedLimits);
                var max = Math.max.apply(null, allowedLimits);

                if (value < min || value > max) {
                    var tkEnabled = 'playtech.mobile.system.tooltip.enabledType' + (isEmptyAllowed
                            ? '.empty'
                            : '');
                    this.message = i18n.t(tkEnabled, min, max);
                    return false;
                }
            }
            // check for Unlimited if not permitted
            if (!options.noLimitsAllowed && value === Number(options.UNLIMITED_AMOUNT)) {
                this.message = i18n.t('playtech.mobile.system.user.tooltip.limit.regexp');
                return false;
            }

            return true;
        };

        validationConfig.betLimit.fn.fn = function($inputs, config, form) {
            var options = form.options.data;
            var betConfig = options.betLimitsConfig;
            var data = _.mapObject(form.data(), value => Number(value.replace(/'/, '')));
            var fieldName = $inputs[0].name;
            var value = Number($inputs.val().replace(/'/, ''));
            var viewFieldTypesMatchStr = 'daybet|weekbet|monthbet|sessionbet';
            var validationFieldTypesMatchStr = 'day|week|month|session';

            // check another fields
            var fields = form.$el.find('[data-validation-type=betLimit]');

            if (!fields.length) {
                fields = form.$el.find('.fn-bet-limit-generic');
            }

            if (!form.validationInProgress) {
                form.validationInProgress = true;

                _.each(fields, function(field) {
                    form.validateField($(field), options);
                });

                form.validationInProgress = false;
            }
            // format to {day:, week:, month:} for easy validation
            var formattedData = _.keys(data).reduce(function(memo, limitName) {
                var matched = limitName.match(viewFieldTypesMatchStr);

                if (matched) {
                    memo[matched[0].split('bet')[0]] = data[limitName];
                }

                return memo;
            }, {});

            var isAllLimitsAreEmpty = function(periods) {
                return _.every(_.pairs(periods), function(pair) {
                    return pair[1] === 0;
                });
            };

            if (!betConfig.mandatory && isAllLimitsAreEmpty(formattedData)) {
                this.message = i18n.t('playtech.mobile.system.tooltip.limits.betLimitRequired');
                return false;
            }

            if (betConfig.mandatory && value === 0) {
                this.message = i18n.t('playtech.mobile.system.tooltip.limits.allbetLimitsRequired');
                return false;
            }
            // check daily <= weekly <= monthly
            var currentLimitName = fieldName.match(validationFieldTypesMatchStr)[0];

            if (!isFitLimitAmount[currentLimitName](formattedData)) {
                this.message =
                        i18n.t('playtech.mobile.system.tooltip.limits.error.' + currentLimitName + 'Limit');
                return false;
            }

            if (betConfig.predefinedType === 'enabled') {
                if (betConfig.noLimitsAllowed && value === Number(betConfig.unlimitedAmount) || value
                        === 0) {
                    return true;
                }

                var allowedLimits = betConfig.predefinedLimits.map(Number);

                if (betConfig.noLimitsAllowed) {
                    allowedLimits.pop();
                }

                var min = Math.min.apply(null, allowedLimits);
                var max = Math.max.apply(null, allowedLimits);

                if (value < min || value > max) {
                    var tkEnabled = 'playtech.mobile.system.tooltip.enabledType' + (betConfig.mandatory
                            ? ''
                            : '.empty');
                    this.message = i18n.t(tkEnabled, min, max);

                    return false;
                }
            }

            if (!betConfig.noLimitsAllowed && value === Number(betConfig.unlimitedAmount)) {
                this.message = i18n.t('playtech.mobile.system.user.tooltip.limit.regexp');
                return false;
            }

            return true;
        };

        return validationConfig;
    };
});
